import type { GoNoGo } from '@/types/roadmap.types';
import { ActionChip } from './Chip';

interface GoNoGoBadgeProps {
  value: GoNoGo;
  className?: string;
}

/**
 * The call-to-action chip (Primary / Conditional / Monitor).
 * Maps the 5-value `go_no_go` enum onto the 3 visual action tiers defined in
 * `Chip.tsx`. `no_go` renders nothing.
 */
export default function GoNoGoBadge({ value, className }: GoNoGoBadgeProps) {
  return <ActionChip value={value} className={className} />;
}
